import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { v4 } from 'uuid';
import * as S from './styles';
import { InfoBlock } from '~/components';

const DataList = ({ data }) => {
  const { t } = useTranslation();

  const parseStats = () => {
    let resultantArray = data.statsDescriptions;
    if (resultantArray.length > 8) {
      resultantArray.splice(3, 0, { property: '' });
    }
    resultantArray = resultantArray.map(({ property, description }) => {
      return (
        <InfoBlock key={v4()} label={t(description)} value={data[property]} />
      );
    });

    return resultantArray;
  };

  return (
    <S.DataList>{data && data.statsDescriptions && parseStats()}</S.DataList>
  );
};

DataList.propTypes = {
  data: PropTypes.object,
};

DataList.defaultProps = {
  data: { statsDescriptions: [] },
};

export default DataList;
